import ConfigData from 'config/ConfigData';

const MembershipOfSelectCommitteesFilters = [
  {
    name: 'Select Committees',
    pages: ['InfluenceContacts', 'Stakeholders'],
    type: 'membership',
    subtype: 'MembershipOfSelectCommittees',
    searchState: 'SeneddOrHolyroodCondition',
    filterName: 'selectCommittees',
    options: [],
    prefix: 'select',
    optionSelected: '',
    updateFilter: true,
    configHidden: ConfigData?.filters?.selectCommittees?.configHidden,
  },
];

const LordSelectCommitteesFilters = [
  {
    name: 'Lords Select Committees',
    pages: ['InfluenceContacts', 'Stakeholders'],
    type: 'membership',
    subtype: 'MembershipOfLordsSelectCommittees',
    searchState: 'SeneddOrHolyroodCondition',
    filterName: 'lordsSelectCommittees',
    options: [],
    prefix: 'lords-select',
    optionSelected: '',
    configHidden: ConfigData?.filters?.lordsSelectCommittees?.configHidden,
  },
];

export { LordSelectCommitteesFilters };
export default MembershipOfSelectCommitteesFilters;
